export const texts = {
  searchUsersAndTraits: "Search users and traits",
};
